import { render, staticRenderFns } from "./ResearchFrontPage.vue?vue&type=template&id=d2dff776"
import script from "./ResearchFrontPage.vue?vue&type=script&lang=js"
export * from "./ResearchFrontPage.vue?vue&type=script&lang=js"
import style0 from "./ResearchFrontPage.vue?vue&type=style&index=0&id=d2dff776&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2dff776')) {
      api.createRecord('d2dff776', component.options)
    } else {
      api.reload('d2dff776', component.options)
    }
    module.hot.accept("./ResearchFrontPage.vue?vue&type=template&id=d2dff776", function () {
      api.rerender('d2dff776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchFrontPage.vue"
export default component.exports